import { combineReducers } from 'redux';
import championshipCalendar from './mxi/championshipCalendar';
import championshipPlayerPool from './mxi/championshipPlayerPool';

export default combineReducers({
    championshipCalendar,
    championshipPlayerPool,
});



// WEBPACK FOOTER //
// ./src/reducers/app/mxi.js